export default __webpack_public_path__ + "static/media/beef.d2f2ff6e.jpg";